import { Component, Vue } from 'vue-property-decorator';

@Component<TopDualLogo>({
  components: {
  },
})
export default class TopDualLogo extends Vue {

  public mounted() {
    //
  } 
}
